import enLocale from 'date-fns/locale/en-US'
import esLocale from 'date-fns/locale/es'
import ptLocale from 'date-fns/locale/pt'
import thLocale from 'date-fns/locale/th'
import nbLocale from 'date-fns/locale/nb'
import ruLocale from 'date-fns/locale/ru'
import ukLocale from 'date-fns/locale/uk'
import plLocale from 'date-fns/locale/pl'

export default class ProfileHelper {
  static localeMap = {
    en: enLocale,
    es: esLocale,
    pt: ptLocale,
    th: thLocale,
    no: nbLocale,
    ru: ruLocale,
    uk: ukLocale,
    pl: plLocale,
  }

  static isAuth = () => localStorage.hasOwnProperty('token')

  static getToken = () => localStorage.getItem('token')

  static getRefreshToken = () => localStorage.getItem('refresh_token')

  static setToken = (token, refreshToken) => {
    if (token) localStorage.setItem('token', token)

    if (refreshToken) localStorage.setItem('refresh_token', refreshToken)
  }

  static removeToken = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('refresh_token')
  }

  static getCurrentLocale = (locale = 'en', weekStartsOn = 1) => {
    const appLocale = window.localStorage.getItem('lang')
    const currentLocale = this.localeMap[appLocale || locale]
    currentLocale.options.weekStartsOn = weekStartsOn

    return currentLocale
  }
}
